import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Funding from "@/pages/Funding";
import Alerts from "@/pages/Alerts";
import Profile from "@/pages/Profile";
import ProposalBuilder from "@/pages/ProposalBuilder";
import NotificationAnalyzer from "@/pages/NotificationAnalyzer";
import PublicDossier from "@/pages/PublicDossier";
import Plagiarism from "@/pages/Plagiarism";
import Papers from "@/pages/Papers";
import PaperBuilder from "@/pages/PaperBuilder";
import Learn from "@/pages/Learn";
import FreeTools from "@/pages/FreeTools";
import Thesis from "@/pages/Thesis";
import ThesisBuilder from "@/pages/ThesisBuilder";
import Travel from "@/pages/Travel";
import Templates from "@/pages/Templates";
import Quiz from "@/pages/Quiz";
import Consultancy from "@/pages/Consultancy";
import Discovery from "@/pages/Discovery";
import Analytics from "@/pages/Analytics";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AppShell from "@/components/AppShell";
import "@/App.css";

function Private({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/p/:id" element={<PublicDossier />} />
          <Route path="/app" element={<Private><Dashboard /></Private>} />
          <Route path="/app/funding" element={<Private><Funding /></Private>} />
          <Route path="/app/alerts" element={<Private><Alerts /></Private>} />
          <Route path="/app/analyzer" element={<Private><NotificationAnalyzer /></Private>} />
          <Route path="/app/plagiarism" element={<Private><Plagiarism /></Private>} />
          <Route path="/app/papers" element={<Private><Papers /></Private>} />
          <Route path="/app/papers/:id" element={<Private><PaperBuilder /></Private>} />
          <Route path="/app/thesis" element={<Private><Thesis /></Private>} />
          <Route path="/app/thesis/:id" element={<Private><ThesisBuilder /></Private>} />
          <Route path="/app/travel" element={<Private><Travel /></Private>} />
          <Route path="/app/templates" element={<Private><Templates /></Private>} />
          <Route path="/app/quiz" element={<Private><Quiz /></Private>} />
          <Route path="/app/free-tools" element={<Private><FreeTools /></Private>} />
          <Route path="/app/consultancy" element={<Private><Consultancy /></Private>} />
          <Route path="/app/discovery" element={<Private><Discovery /></Private>} />
          <Route path="/app/analytics" element={<Private><Analytics /></Private>} />
          <Route path="/app/learn" element={<Private><Learn /></Private>} />
          <Route path="/app/profile" element={<Private><Profile /></Private>} />
          <Route path="/app/proposals/:id" element={<Private><ProposalBuilder /></Private>} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
